<template>
  <b-row>
    <b-col md="6">
      <card class="stacked-form">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
         <div class="row">
           <div class="col-md-6">
              <div>
                <fg-input label="Name">
                  <p>{{model.name !== null ? model.name : '-'}}</p>
                </fg-input>
                <fg-input label="Email">
                  <p>{{model.email !== null ? model.email : '-'}}</p>
                </fg-input>
                <fg-input label="Dibuat pada tanggal">
                  <p>{{model.createdAt !== null ? model.createdAt : '-'}}</p>
                </fg-input>
                <fg-input label="Active">
                  <p><l-switch :width="30" v-model="model.isActive" type="primary" :active-value="1" :inactive-value="0" @change="changeSwitch('isActive', 'Available',  model.isActive)"></l-switch></p>
                </fg-input>
              </div>
           </div>
         </div>
        <edit-button v-if="role === 'owner'"/>
        <back-button/>
      </card>
    </b-col>
  </b-row>
</template>

<script>
  import {Switch} from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import Edit from '@/components/Buttons/Edit'
  import Back from '@/components/Buttons/Back'

  export default {
    components: {
      LProgress,
      EditButton: Edit,
      BackButton: Back,
      LSwitch: Switch
    },
    data () {
      return {
        role: this.$store.getters['account/accountData'].roles[0].name,
        isLoading: false,
        apiUrl: {
          profile: window.AppConfig.apiUrl + 'profile'
        },
        model: {
          name: '',
          email: '',
          isActive: 1,
          createdAt: ''
        }
      }
    },
    watch: {
      '$route.params.uuid': function (val) {
        this.getDetail()
      }
    },
    mounted () {
      this.getDetail()
    },
    methods: {
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.profile + '/' + this.$route.params.id)
        .then(response => {
          this.model.uniqueNumber = response.data.uniqueNumber
          this.model.name = response.data.name
          this.model.email = response.data.email
          this.model.createdAt = response.data.created_at
          this.model.isActive = response.data.isActive ? 1 : 0
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      changeSwitch (prop, label, value) {
        this.$swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonClass: 'btn btn-warning mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            let data = {}
            data[prop] = value
            data['uuid'] = this.$route.params.uuid
            this.$http.put(window.AppConfig.apiUrl + 'profile' + '/' + this.$route.params.id, data)
            .then(response => {
              this.$store.dispatch('notification/success', label + ' Successfully updated.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
              this.model[prop] = value ? 0 : 1
            })
          } else {
            this.model[prop] = value ? 0 : 1
          }
        })
      },
      getUrlPath (value) {
        return window.AppConfig.baseApiUrl + value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Users/Owners/Show.vue